import { getShippingCharges } from "../../Services/MainServices";

// Shipping Charges Action Types
export const FETCH_SHIPPING_REQUEST = "FETCH_SHIPPING_REQUEST";
export const FETCH_SHIPPING_SUCCESS = "FETCH_SHIPPING_SUCCESS";
export const FETCH_SHIPPING_FAILURE = "FETCH_SHIPPING_FAILURE";

export const featchShippingCharges = (payload) => async (dispatch) => {
  dispatch({ type: FETCH_SHIPPING_REQUEST });

  try {
    const response = await getShippingCharges(payload);
    // console.log("response ======>", JSON.stringify(response, null, 12));
    if (response?.status === 200 && response.data?.status === "success") {
      dispatch({
        type: FETCH_SHIPPING_SUCCESS,
        payload: response.data.data, // Adjust this path based on actual API structure
      });
    } else {
      // console.log("Error ======>", JSON.stringify(response, null, 12));
      const message =
        response?.data?.message || "Failed to fetch shipping charges.";
      dispatch({ type: FETCH_SHIPPING_FAILURE, payload: message });
    }
  } catch (error) {
    // console.log("Error ======>", JSON.stringify(error, null, 12));
    const message =
      error?.response?.data?.message ||
      error?.message ||
      "Error fetching shipping charges.";
    dispatch({ type: FETCH_SHIPPING_FAILURE, payload: message });
    // toast.error(message);
  }
};
